import { FunctionComponent } from 'preact';
import './MastheadSkeleton.css';

export const MastheadSkeleton: FunctionComponent = () => {
  return <div className="masthead-skeleton" />;
};
